/*
 * @Description: Display image with responsive container
 * @Author: Jack Deng
 * @Date: 2021-03-09 15:05:13
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-06-30 16:10:49
 * @FilePath: /unifyxp-v2-store-portal/src/components/Upload/ImageDisplay/index.tsx
 */

import { DeleteOutlined, EditOutlined, RedoOutlined } from '@ant-design/icons';
import React from 'react';

import { ImageFile } from './imageDisplay';

import { get, isNumber } from 'lodash';
import styles from './style.module.less';
import { mediaTypeCheck } from 'src/tools/helper';
import { MediaType } from 'src/types/common/common';

type Props = {
  imageUrl: string;
} & (
  | {
      type: Type.Responsive;
      width: number;
      height: number;
    }
  | {
      type: Type.Fill;
      height: number;
      width?: never;
    }
) &
  (
    | {
        hideAction?: false | undefined;
        fileList: Array<ImageFile>;
        hideEdit?: boolean;
        hideRemove: boolean;
        hideReplace?: boolean;
        hideOriginalName: boolean;
        hideSize: boolean;
        onRemove: (file: ImageFile) => void;
        onReplace: (image: ImageFile, index: number) => void;
        onEdit: (image: ImageFile, index: number) => void;
        index?: number;
      }
    | {
        hideAction?: true;
        hideRemove?: false;
        hideEdit?: boolean;
        hideReplace?: boolean;
        hideOriginalName?: false;
        hideSize?: false;
        fileList?: never;
        onRemove?: never;
        onReplace?: never;
        onEdit?: never;
        index?: number;
      }
  );

export enum Type {
  Responsive = 'Responsive', //其他用
  Fill = 'Fill', //上传专用
}

function ImageDisplay({
  type,
  imageUrl,
  width,
  height = 180,
  hideAction,
  fileList = [],
  hideRemove,
  hideOriginalName,
  hideSize,
  hideEdit,
  hideReplace,
  onRemove,
  onReplace,
  onEdit,
  index,
}: Props) {
  const i = isNumber(index) ? index : fileList.length - 1;
  const image = fileList[i];
  const isVideo = mediaTypeCheck(image) === MediaType.Video;
  const originalName = get(image, 'originalName') || '';
  const formatOriginName =
    originalName.length > 53 ? originalName.slice(0, 53) + '...' : originalName;
  return (
    <div
      className={styles.container}
      style={{
        width: type === Type.Responsive ? width : width || undefined,
        height,
      }}>
      <div
        className={styles.image}
        style={{
          width: type === Type.Responsive ? width : width || undefined,
          height,
          backgroundImage: `url('${imageUrl}')`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundSize: type === Type.Responsive ? 'cover' : 'contain',
        }}
      />
      {!hideAction && (
        <div className={styles.action}>
          <div className={styles.title}>
            {!hideOriginalName && (formatOriginName || '')}
          </div>
          <div className={styles.content}>
            {!hideSize && image.size && (
              <div className={styles.left}>
                {`${image.size ? Math.floor(image.size / 1024) : '0'}KB`}
              </div>
            )}

            <div className={styles.right}>
              {!hideReplace && (
                <span className={styles.actionBtn}>
                  <RedoOutlined
                    className={styles.icon}
                    onClick={() => {
                      onReplace(image, i);
                    }}
                  />
                </span>
              )}
              {!hideEdit && !isVideo && (
                <span className={styles.actionBtn}>
                  <EditOutlined
                    className={styles.icon}
                    onClick={() => {
                      onEdit(image, i);
                    }}
                  />
                </span>
              )}
              {!hideRemove && (
                <span
                  className={styles.actionBtn}
                  style={{ color: '#FF695F' }}
                  onClick={onRemove.bind(this, fileList[i])}>
                  <DeleteOutlined className={styles.icon} />
                </span>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ImageDisplay;
